<template>
<transition name="slide-up">
  <section @click.self="toggleTab(false)" v-if="isTabOpened" class="fixed w-full h-full top-0 left-0 z-50 flex bg-purple-200 bg-opacity-10 px-2">
    <main class="tab-size-position">
      <div @click="toggleTab(false)" class="exit-popup-btn">
        <h6>x</h6>
      </div>

      <section class="space-y-3"> 
        <div class="w-28 h-28 rounded-full overflow-hidden mx-auto shadow-xl">
          <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all select-none w-full h-full" :src="chatRoomInfo.icon" :alt="chatRoomInfo.name">
        </div>
        
        <div class="space-y-1">
          <h2 class="font-bold text-3xl text-center">{{chatRoomInfo.name}}</h2>
          <h6 class="text-xs text-gray-400 text-center" v-if="creatorUsername">Created by {{creatorUsername}}</h6>
          <h6 class="text-sm text-gray-800 text-center font-bold" v-if="chatRoomInfo.membersId">{{Object.keys(chatRoomInfo.membersId).length}} members</h6>
        </div>

        <div v-if="!isAlreadyMember" @click="$emit('joinChatRoom',chatRoomInfo.id)" class="pop-click px-4 py-4 bg-purple-700 rounded-lg text-white text-center uppercase flex justify-center space-x-1 w-max mx-auto text-xs">
          <h6 class="table my-auto">Join Chat room</h6>
        </div>
        <div v-else class="text-gray-400 text-center uppercase flex justify-center space-x-1 w-max mx-auto text-xs">
          You are already a member
        </div>

      </section>

      <section class="grid grid-cols-1 xl:grid-cols-2 gap-5 xl:gap-24 px-10 overflow-auto py-5 mt-5">
        <div class="overflow-auto purple-small-scroll pr-4 row-start-2 xl:row-start-1">
          <p class="text-xs xl:text-sm text-gray-400" v-if="chatRoomInfo.description"> {{chatRoomInfo.description}} </p>
          <p class="text-xs xl:text-sm text-gray-400 " v-else> No description provided. </p>
        </div>
        <div class="row-start-1">
          <div class="w-max mx-auto xl:m-0">
            <div v-for="(member,key) in chatMembersIcon" :key="key" class="w-10 h-10 rounded-full overflow-hidden -mr-2 bg-purple-800 z-10 inline-block">
              <img :src="member" alt="member.username" class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all select-none z-10">  
            </div>
          </div>
        </div>
      </section>
      
    </main>
  </section>
</transition>  
</template>

<script>
import firebase from "firebase/app";

export default {
  data(){
    return {
      creatorUsername : "",
      chatRoomInfo : null,
      isTabOpened : false,
      chatMembersIcon : {},
      isAlreadyMember : false
    }
  },
  emits : ['joinChatRoom'],
  methods : {
    toggleTab(toOpen = null){
      if(toOpen === null)this.isTabOpened = !this.isTabOpened;
      this.isTabOpened = toOpen;
      if(!toOpen){
        this.chatMembersIcon = {},
        this.chatRoomInfo = null
      }
    },
    setChatRoomInfo(infos = null,id = null,isAlreadyMember = false){
      this.isAlreadyMember = isAlreadyMember;
      if(!infos)return;
      this.chatRoomInfo = infos;
      this.chatRoomInfo.id = id;
      this.toggleTab(true);
      if(infos.membersId)this.setChatMembers(infos.membersId);
    },
    setChatMembers(membersIds){
      const memberRef = firebase.database().ref().child("users");
      for(var memberId in membersIds){
        const id = memberId;
        memberRef.child(id).child('icon').get().then((snapshot) => {
          if (snapshot.exists()) {  
            this.chatMembersIcon[id] = snapshot.val();
          }
        }).catch((error) => {
          console.error(error);
        });
        if(id === this.chatRoomInfo.creatorId){
          memberRef.child(id).child('username').get().then((snapshot) => {
            if (snapshot.exists()) {  
              this.creatorUsername = snapshot.val();
            }
          }).catch((error) => {
            console.error(error);
          });
        }
       
      }
    }
  }
}
</script>

<style>

</style>